export const colours = {
    core: {
        black: "#151818",
        white: "#ffffff",
    },
    gray: {
        gray90: "#2C2F2F",
        gray80: "#444646",
        gray70: "#5B5D5D",
        gray60: "#737474",
        gray50: "#8A8B8B",
        gray40: "#A1A3A3",
        gray30: "#B9BABA",
        gray20: "#D0D1D1",
        gray10: "#E8E8E8",
    },
    midnightBlue: {
        blue: "#110F3C",
        blue120: "#121135",
        blue140: "#13132E",
        blue160: "#131426",
        blue80: "#413F63",
        blue40: "#A09FB1",
        blue20: "#CFCFD8",
        blue10: "#E7E7EB",
        blue5: "#F3F3F5",
        blueBG: "#FAFAFB",
    },
    orange: {
        orange: "#EF9752",
        orange110: "#D98A4C",
        orange120: "#C37E46",
        orange140: "#98643B",
        orange80: "#F2AC75",
        orange40: "#F9D5BA",
        orange20: "#FCEADC",
        orange15: "#FDEFE5",
        orange10: "#FDF5EE",
    },
    chartColours: {
        teal: "#73C7BD",
        yellow: "#F3DB5C",
        coral: "#EF7D71",
    },
    categorical: {
        one: "#0D1425",
        two: "#EEDCB7",
        three: "#555B79",
        four: "#DE9D73",
        five: "#9A6567",
        six: "#223C60",
        seven: "#CB745F",
        eight: "#E0C299",
        nine: "#746072",
        ten: "#FCF5DC",
    },
    notifications: {
        info: "#006FF1",
        info10: "#E6EEF8",
        info50: "#80B7F8",
        info20: "#CCE2FC",
    },
    success: {
        success: "#028A28",
        success50: "#81C494",
        success20: "#CCE8D4",
    },
    error: {
        error: "#A50000",
        error10: "#F6E5E5",
        error50: "#D28080",
        error20: "#EDCCCC",
    },
    warning: {
        warn: "#CC4E00",
        warn10: "#F9ECE3",
        warn50: "#E5A780",
        warn20: "#F5DCCC",
    },
    action: {
        active: "#275C8B",
    }

} as const;

export const boxShadows = {
    levelOne: "1px 2px 5px 0px #1518181A",
    levelTwo: "1px 2px 6px 1px #15181826",
    levelFive: "2px 8px 8px 3px #15181840",
} as const